import { useContext } from "react";
import get from "lodash.get";
import { DataContext } from "./DataContext";

export const useReviews = () => get(useContext(DataContext), "reviews", []);

export const useTrustpilotInfo = () => get(useContext(DataContext), "trustpilotInfo", []);

export const useReferralProgramConfig = () => get(useContext(DataContext), "referralProgramConfig", {});

export const usePageName = () => get(useContext(DataContext), "pageName", "");

export const useCMSLanguageData = () => get(useContext(DataContext), "cmsLanguagesData", "");

export const useServerSideStoryblokPages = () => get(useContext(DataContext), "serverSideStoryblokPages", {});
